module.exports = __webpack_public_path__ + "static/img/4471_phase_function_Paper_PointsHejduk_Prediction.5df756c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4471_phase_function_Paper_PointsHejduk_Prediction.png
// module id = z8MF
// module chunks = 0